const GoogleClientId = '982553495325-7r104vlcq6hp3lfl696vb7mn2tvmu92i.apps.googleusercontent.com';
const FacebookClientId = '1548700322004185';

module.exports = {
	GoogleClientId,
	FacebookClientId,
};
